import axios from "axios";
import ProjectUtils from "../../utils/project-utils.js";
import {toast} from "react-toastify";

const API_URL = import.meta.env.VITE_API_URL;

const RegisteredOccurrenceVehiclesService = {
    apply: async (payload) => axios.post(API_URL + "/registered_occurrence_vehicles/apply", payload).then(({ data }) => data).catch((err) => { throw err }),
    
    openSentryView: async (id) =>
        axios.get(API_URL + `/occurrence/open-sentryview/${id}`)
            .then(() => {
                toast.success(`A ocorrência ${id} será aberta no SentryView.`);
            })
            .catch((error) => {
                console.error(error);
                ProjectUtils.swalErrorMessage("", "Ocorreu um erro ao abrir o cadastro no SentryView.", "Ok");
                throw error;
            }),
}

export default RegisteredOccurrenceVehiclesService;